export const BPR_CONSUMER_SCORE_MODELS = {
  vantage4: "Vantage 4.0",
  fico8: "FICO 8",
  fico5: "FICO 5",
};
